<div class="input-group float-right search-box-width">
  <input type="text" class="form-control font-1rem" [(ngModel)]="searchKey" name="searchInput" #searchInput="ngModel"
    [placeholder]="searchPlaceholder">
  <div class="input-group-append">
    <button class="btn border maroon-bg" (click)="search()"><i class="fa fa-search"></i></button>
  </div>
</div>